import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { UseFormReturn } from 'react-hook-form';
import AttachmentsInput from '../../../components/attachments/AttachmentsInput';
import { TicketFormData } from '../types';

interface AttachmentsStepProps {
  form: UseFormReturn<TicketFormData>;
  ticketSummary: { title: string; id: string; status: string };
  createdTicketId: string;
}

export const AttachmentsStep: React.FC<AttachmentsStepProps> = ({ 
  form, 
  ticketSummary, 
  createdTicketId 
}) => {
  const { control } = form;

  return (
    <Box sx={{ my: 2 }}>
      <Paper elevation={1} sx={{ p: 2, mb: 3, bgcolor: '#f8f9fa' }}>
        <Typography variant="subtitle1" fontWeight={500}>
          Ticket "{ticketSummary.title}" created successfully!
        </Typography>
      </Paper>
      
      <Box>
        <Typography variant="subtitle1" sx={{ mb: 1.5, fontWeight: 500, color: '#34495e' }}>
          Add Attachments
        </Typography>
        <Typography variant="body2" sx={{ mb: 2, color: '#666' }}>
          You can now add files to this ticket. Skip this step if no attachments are needed.
        </Typography>
        <AttachmentsInput
          control={control}
          name="attachments"
          ticketId={createdTicketId}
          sx={{ width: '100%' }}
        />
      </Box>
    </Box>
  );
};